import clsx from 'clsx'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  BackButton,
  PanelBackground,
  panelClass,
} from '@/components/widget-components'

const titleText = clsx(
  'text-md md:text-[40px] lg:text-[48px] leading-tight break-words'
)

type PaytrieWelcomeLeftPanelProps = {
  titleKey: string
}

export default function PaytrieWelcomeLeftPanel({
  titleKey,
}: PaytrieWelcomeLeftPanelProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const parent = searchParams.get('parent')

  return (
    <PanelBackground
      className={panelClass}
      data-testid="container-welcome-left-panel"
    >
      <BackButton
        onClick={() => navigate('/')}
        className="absolute top-8 md:top-5 left-5 md:left-10"
        data-testid="btn-welcome-back"
      >
        &#x27f5;
      </BackButton>
      <div
        className="hidden md:block py-5 md:py-10 md:px-4 md:pr-8"
        data-testid="container-welcome-heading"
      >
        <h2
          className={clsx(titleText, 'dark:text-sun text-clementine')}
          data-testid="text-welcome-title"
        >
          {t(titleKey)}
        </h2>
        <div
          className={clsx(titleText, 'md:mt-2')}
          data-testid="text-welcome-subtitle"
        >
          {t('welcome.subtitle')}
        </div>
      </div>
      {window.self === window.top && parent !== 'landing' && (
        <div
          className="absolute top-10 right-0"
          data-testid="container-welcome-extra"
        ></div>
      )}
    </PanelBackground>
  )
}
